import Vue from "vue";

Vue.directive("open-mobile-navigation",
    {
        bind(el, binding)
        {
            el.onclick = function(event)
            {
                if (document.querySelector(".mobile-navigation"))
                {
                    document.querySelector(".mobile-navigation").classList.toggle("open");
                    document.querySelector("body").classList.toggle("menu-is-visible");
                    document.querySelector("body").classList.remove("basket-open");
                }
            };
        }
    });
